"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Explanation = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _iconButton = require("../icon-button");

var _SvgBtConversation = require("../svg/icons/SvgBtConversation");

var _dropdown = require("../dropdown");

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["dropdownCoreProps"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

(0, _loadStyles.default)(".c0a1c19ef{display:inline-flex;flex-direction:column}.c837ed202{flex-direction:column-reverse}");
var styles = {
  root: 'c0a1c19ef',
  '--direction-up': 'c837ed202'
};

var Explanation = function Explanation(props) {
  var classes = props.classes,
      children = props.children,
      dropdownProps = props.dropdownProps,
      iconButtonProps = props.iconButtonProps,
      stopPropagation = props.stopPropagation;
  var cn = (0, _useStyles.useStyles)(styles, classes);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var onOpenHandler = (0, _react.useCallback)(function (event) {
    if (stopPropagation) {
      event.stopPropagation();
    }

    setActive(true);
  }, [stopPropagation]);
  var onCloseHandler = (0, _react.useCallback)(function () {
    setActive(false);
  }, []);
  var innerDropdownProps = (0, _react.useMemo)(function () {
    var _dropdownProps$dropdo = dropdownProps.dropdownCoreProps,
        dropdownCoreProps = _dropdownProps$dropdo === void 0 ? {} : _dropdownProps$dropdo,
        otherDropdownProps = (0, _objectWithoutProperties2.default)(dropdownProps, _excluded);
    return _objectSpread({
      dropdownCoreProps: _objectSpread({
        offsetTarget: 'iconButton'
      }, dropdownCoreProps)
    }, otherDropdownProps);
  }, [dropdownProps]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.direction[innerDropdownProps.direction || 'down'])
  }, /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, (0, _extends2.default)({
    onClick: onOpenHandler,
    onMouseLeave: onCloseHandler,
    type: "button"
  }, iconButtonProps), /*#__PURE__*/_react.default.createElement(_SvgBtConversation.SvgBtConversation, null)), /*#__PURE__*/_react.default.createElement(_dropdown.Dropdown, (0, _extends2.default)({
    view: "tooltip",
    active: active,
    onOverlayClick: onCloseHandler
  }, innerDropdownProps), children));
};

exports.Explanation = Explanation;
Explanation.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  iconButtonProps: _propTypes.object,
  dropdownProps: _propTypes.object,
  stopPropagation: _propTypes.bool,

  /* styling modificators */

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
Explanation.defaultProps = {
  classes: {},
  dropdownProps: {},
  iconButtonProps: {},
  stopPropagation: false
};